import Chart from 'chart.js/auto';
import { debounce } from '@/utilities/helpers';

import ChartDataLabels from 'chartjs-plugin-datalabels';
// Register the plugin globally
Chart.register(ChartDataLabels);

export const initBarChart = ($chart) => {
    let label = $chart.dataset.label;
    let height = 35;
    let dataset = JSON.parse($chart.dataset.dataset);
    let colour = $chart.dataset.colour;

    let style = $chart.dataset.style || '';
    let show_labels = style.includes('labels');

    let datalabel_value_alignment = 64;

    let gradient_blue_dark = $chart.getContext('2d').createLinearGradient(0, height, 0, 0);
    gradient_blue_dark.addColorStop(1, '#5C9FB0');
    gradient_blue_dark.addColorStop(0, '#1E6F97');

    let gradient_blue_light = $chart.getContext('2d').createLinearGradient(0, height, 0, 0);
    gradient_blue_light.addColorStop(1, '#B5D8CD');
    gradient_blue_light.addColorStop(0, '#239890');

    let gradient_turquoise_dark = $chart.getContext('2d').createLinearGradient(0, height, 0, 0);
    gradient_turquoise_dark.addColorStop(1, '#B4D7CE');
    gradient_turquoise_dark.addColorStop(0, '#24988F');

    let gradient_grey_alt = $chart.getContext('2d').createLinearGradient(0, height, 0, 0);
    gradient_grey_alt.addColorStop(1, '#edf0f2');
    gradient_grey_alt.addColorStop(0, '#cbd3d7');

    let greys = [
        '#889DA2',
        '#CAD2D6'
    ];

    let gradients = [
        gradient_blue_dark,
        gradient_blue_light
    ];

    dataset.forEach((data, index) => {
        if (colour === 'grey') {
            Object.assign(data, {
                backgroundColor: greys[index],
                hoverBackgroundColor: greys[index],
                stack: 'stack1',
                datalabels: { display: (index === 0 && show_labels) },
            });
        } else if (colour === 'turquoise-transparent') {
            Object.assign(data, {
                backgroundColor: (index === 0) ? gradient_turquoise_dark : '#E7F2F0',
                hoverBackgroundColor: (index === 0) ? gradient_turquoise_dark : '#E7F2F0',
                stack: 'stack1',
                datalabels: { display: (index === 0 && show_labels) },
            });
        } else if (colour === 'blue-transparent') {
            Object.assign(data, {
                backgroundColor: (index === 0) ? gradient_blue_dark : '#E1F1F5',
                hoverBackgroundColor: (index === 0) ? gradient_blue_dark : '#E1F1F5',
                stack: 'stack1',
                datalabels: { display: (index === 0 && show_labels) },
            });
        } else if (colour === 'grey-transparent') {
            Object.assign(data, {
                backgroundColor: (index === 0) ? '#899CA3' : '#EEF0F2',
                hoverBackgroundColor: (index === 0) ? '#899CA3' : '#EEF0F2',
                stack: 'stack1',
                datalabels: { display: (index === 0 && show_labels) },
            });
        } else if (colour === 'grey-light-transparent') {
            Object.assign(data, {
                backgroundColor: (index === 0) ? '#CAD2D6' : '#EEF0F2',
                hoverBackgroundColor: (index === 0) ? '#CAD2D6' : '#EEF0F2',
                stack: 'stack1',
                datalabels: { display: (index === 0 && show_labels) },
            });
        } else if (colour === 'grey-alt') {
            Object.assign(data, {
                backgroundColor: (index === 1) ? gradient_grey_alt : '#EEF0F2',
                hoverBackgroundColor: (index === 1) ? gradient_grey_alt : '#EEF0F2',
                stack: 'stack1',
                datalabels: { display: (index === 0 && show_labels) },
            });
        }
        else {
            Object.assign(data, {
                backgroundColor: gradients[index],
                hoverBackgroundColor: gradients[index],
                stack: 'stack1',
                datalabels: { display: (index === 0 && show_labels) },
            });
        }
    })

    let data = {
        labels: [label],
        datasets: dataset
    };

    let chart = new Chart($chart, {
        type: 'bar',
        data: data,
        options: {
            indexAxis: 'y',
            responsive: true,
            layout: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                }
            },
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    enabled: false
                },
                datalabels: {
                    display: false,
                }
            },
            scaleShowLabels: false,
            maintainAspectRatio: true,
            scales: {
                x: {
                    display: false,
                    grid: {
                        display: false
                    },
                    ticks: {
                        display: false,
                    },
                    border: {
                        display: false
                    },
                    offset: false,
                    tickMarkLength: 0,
                },
                y: {
                    display: false,
                    grid: {
                        display: false,
                    },
                    ticks: {
                        display: false,
                    },
                    border: {
                        display: false
                    },
                    tickMarkLength: 0,
                    categoryPercentage: 1.0,
                    barPercentage: 1.0,
                    barThickness: 20,
                }
            }
        }
    });


    if (show_labels) {
        // display inline labels on top of the charts (not tooltip)

        let value = data.datasets[0].data[0];

        // Disable animations as these will more than likely be hidden on page load 
        chart.options.animation = false;

        chart.options.plugins.datalabels = {
            display: false,
            align: (value < datalabel_value_alignment) ? 'right' : 'left',
            offset: 8,
            backgroundColor: (value < datalabel_value_alignment) ? 'transparent' : 'rgba(255,255,255,.5)',
            borderRadius: 3,
            padding: {
                top: 2,
                bottom: 1,
                left: 4,
                right: 4
            },
            anchor: 'end',
            font: {
                family: '"gotham", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                size: 11.5,
                weight: '500',
            },
            color: '#222222',
            formatter: (value, context) => `${value}% ${context.chart.data.labels}`,
        };



    }

    window.addEventListener('resize', debounce(() => chart.resize(), 300));

}